export default __webpack_public_path__ + "static/media/05_photo.ec24bcb2.jpg";